import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "at-delete-dialog"
};
const _hoisted_2 = {
  class: "fa fa-spinner fa-spin",
  style: {
    "margin-right": "5px"
  }
};
import { reactive } from "vue";
import LlSecondaryButton from "@/components/LlSecondaryButton.vue";
import { useEmbeddedReportStore } from "./useEmbeddedReportStore";
export default {
  __name: 'DeleteDashboardDialog',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    leftNavBarState: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const embeddedReportStore = useEmbeddedReportStore();
    embeddedReportStore.alerts = props.alerts;
    const deleteDashboardState = reactive({
      dialog: true,
      loading: false
    });
    const confirm = async () => {
      deleteDashboardState.loading = true;
      embeddedReportStore.deleting = true;
      await embeddedReportStore.deleteDashboard(props.leftNavBarState.deleteDashboardId);
      const index = embeddedReportStore.customReportList.findIndex(item => item.id === props.leftNavBarState.deleteDashboardId);
      embeddedReportStore.customReportList.splice(index, 1);
      embeddedReportStore.deleting = false;
      deleteDashboardState.loading = false;
      embeddedReportStore.deleteDashboardDialog = false;
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_spacer = _resolveComponent("v-spacer");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_row = _resolveComponent("v-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_v_row, {
        justify: "center"
      }, {
        default: _withCtx(() => [_createVNode(_component_v_dialog, {
          modelValue: _unref(embeddedReportStore).deleteDashboardDialog,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(embeddedReportStore).deleteDashboardDialog = $event),
          width: "auto"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_card, null, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, {
              class: "dialog-title"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" Are you sure you want to delete this dashboard? ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [_createVNode(_component_v_spacer), _createVNode(LlSecondaryButton, {
                onClick: _cache[0] || (_cache[0] = $event => _unref(embeddedReportStore).deleteDashboardDialog = false)
              }, {
                default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode(" Cancel ", -1)]))]),
                _: 1
              }), _createVNode(LlSecondaryButton, {
                class: "at-confirm-delete",
                color: "primary",
                variant: "tonal",
                onClick: _cache[1] || (_cache[1] = $event => confirm())
              }, {
                default: _withCtx(() => [_withDirectives(_createElementVNode("i", _hoisted_2, null, 512), [[_vShow, _unref(embeddedReportStore).deleting]]), _createTextVNode(" " + _toDisplayString(_unref(embeddedReportStore).deleting ? "Deleting..." : "Delete"), 1)]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]);
    };
  }
};